import { useMemo } from "react";
import DynamicForm from "@view/common/DynamicForm";
import { DynamicFormSchema } from "@view/common/DynamicForm/DynamicFormContracts";
import styles from "./EmailSlide.module.css";
import DynamicTextField from "@view/common/Components/DynamicFields/DynamicTextField";
import OtpSumbit from "./OtpSubmit";
import emailRegex from "@presentation/regexes/emailRegex";

export interface ILoginWithEmailOtpFormValue {
  email: string;
}

export interface ILoginWithEmailOtpSlideProps {
  callGenerateOtpApi: (email: string) => void;
  className?: string;
  loading?: boolean;
}

const EmailSlide = (props: ILoginWithEmailOtpSlideProps) => {
  
  const onSubmit = (value: ILoginWithEmailOtpFormValue, anyError: boolean) => {
    if (anyError) return;
    props.callGenerateOtpApi(value.email);
  };

  const formSchema = useMemo(() => {
    const schema: DynamicFormSchema<ILoginWithEmailOtpFormValue> = {
      columns: 12,
      submitLabel: "Iniciar sesión",
      submitFieldColumns: 12,
      initValues: {
        email: "",
      },
      fields: [
        {
          columns: 12,
          label: "Correo electrónico",
          name: "email",
          type: "string",
          attributes: {
            placeholder: "Ingresa tu correo",
            messageError: "Por favor completa este dato, debe tener el siguiente formato: ejemplo@gmail.com",
            regexes: [
              { expression: emailRegex },
              { expression: "^.{8,}$" },
            ],
            maxLength: 100,
            required: true,
          }
        },
      ]
    };
    return schema;
  }, []);

  const _className = useMemo(() => (
    [
      styles.root,
      props.className,
    ].filter(x => x !== undefined).join(" ")
  ), [props.className]);

  return (
    <div className={_className}>
      <DynamicForm
        loading={props.loading}
        disabled={props.loading}
        onSubmit={onSubmit as any}
        className={styles.form}
        schema={formSchema}
        context={{
          fieldsMap: {
            "string": DynamicTextField,
          },
          SubmitField: x => <OtpSumbit {...x} label="Enviar código" />,
          requiredIndicator: true
        }}
      />
    </div>
  );

};

export default EmailSlide;
